// extracted by mini-css-extract-plugin
module.exports = {"ko-KR":"icon_ko-KR__WHRBH","impressionTrackingContainer":"icon_impressionTrackingContainer__fyqFR","vc-icon":"icon_vc-icon__SkG29"};